import {
  DateOptions,
  formatDate as formatDatePackage,
} from 'lib/utils/date.util';

/*
 * Any dateFormat and timeFormat given here will be overridden, because the wrong option is used
 * in many sales repositories. Use customFormatDate to fully customize the date format.
 */
export const formatDate = (date: Date, options?: DateOptions): string => {
  const defaultOptions: DateOptions = {
    ...options,
    dateFormat: 'dd M yyyy',
    timeFormat: options?.timeFormat !== undefined ? 'HH:mm:ss' : undefined,
    locale: 'id-ID',
  };

  // The ID locale uses '.' as a separator, so we need to replace it with ':'
  return formatDatePackage(date, defaultOptions).replace(/\./g, ':');
};
